import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import CorporationDialog from "../dialogTypes/CorporationDialog";

function CorporationManageCreateButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, refresh, onClose, onSuccess, createButtonName, customizeErrorMsgCallback, setInitialDataCallback, modifyUrlCallback ,...others } = props;
    const [ open, setOpen ] = useState(false);

    const onOpen = () => {

        setOpen ( true );

    };

    const onDialogClose = () => {

        setOpen ( false );

        if ( onClose ) {

            onClose ();

        }

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        if(refresh) {
            refresh.refresh ();
        }

    };

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <CorporationDialog
                id={id+"create-dialog"}
                mode="create"
                method = "post"
                formId={id+"create-form"}
                title={ schema ? t ( `dialog.title.${id}.create` ) : "" }
                schema={schema}
                open={open}
                onClose={onDialogClose}
                onSuccess={onCreateSuccess}
            />
        </>

    );
}

export default CorporationManageCreateButton;

